import React from 'react';
import styles from './DismissButton.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const DismissButton = ({
  onClick,
}) => {
  return (
    <div className={cx('DismissButton')} onClick={onClick}>
      <svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'
           fill='none' stroke='currentColor' strokeWidth='1' strokeLinecap='round'
           strokeLinejoin='round' className='feather feather-x'>
        <line stroke='#FFFFFF' x1='21' y1='6' x2='6' y2='21' />
        <line stroke='#FFFFFF' x1='6' y1='6' x2='21' y2='21' />
      </svg>
    </div>
  );
};

export default DismissButton;


// WEBPACK FOOTER //
// ./src/app/intro/components/DismissButton/DismissButton.js